import { useState } from 'react';

import { Slide } from 'react-awesome-reveal';

import { useApp } from '../app-context';
import { ChatService } from '../services/ChatService'
import { TSPage } from '../components/commons';
import { ClaimIllness } from '../components/ClaimIllness';

import './ChooseIllnessPage.scss';

const ChooseIllnessPage = function ({ name, onBack, data, btn }) {
    const [state, dispatcher] = useApp();

    const [stateBusy, setStateBusy] = useState(false);
    const [stateSelectedIllness, setStateSelectedIllness] = useState(-1);

    const handleBack = (e) => {
        if (stateBusy) return;

        if (onBack)
            onBack(true, e);
    };

    const handleSelectIllness = (illObj, e) => {
        setStateSelectedIllness(illObj);
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (stateBusy) return;

        setStateBusy(true);

        if (stateSelectedIllness <= 0) {
            return;
        }

        let answer = {
            display: stateSelectedIllness.val,
            value: stateSelectedIllness.id,
            id: btn?.id,
            field: btn?.field
        }

        ChatService.processAnswer(dispatcher, state, answer)
            .then(() => {
                dispatcher({ action: 'closeOverlay', params: 'chooseIllness' });
            })
            .catch(ex => {
                alert(ex);
            }).finally(() => {
                setStateBusy(false);
            });
    };

    data = data || {};

    return (
        <TSPage name={name}>
            <Slide direction="up" duration="500">
                <div className="container on">

                    <div className="header">
                        <button className="btn right" onClick={handleBack}>
                            <img src="img/right-arrow.svg" alt="back" />
                        </button>
                        <div className="title">קטגוריות</div>
                    </div>

                    <div className="content"  style={{ marginLeft: -state?.uiParams?.scrollSize?.w + "px" }}>
                        <div className="page-content">
                            <ClaimIllness ills={data?.["getIllnessLists"]} onIllnessSelected={handleSelectIllness} />
                        </div>
                    </div>
                    <div className="blueLine"></div>
                    <div className="dialog-buttons">
                        <button className="orange" onClick={handleSubmit}>אישור</button>
                        <button onClick={handleBack}>ביטול</button>
                    </div>
                </div>
            </Slide >
        </TSPage >
    );
}

export { ChooseIllnessPage }